import React, { ReactNode } from 'react';
import { WellnessPlanTable } from './components/WellnessPlanTable';
import { Container } from '../../../../components/Container';
import { SectionHeading } from '../../../../components/SectionHeading';
import { WELLNESS_PLAN_BENEFIT_DETAILS, WellnessPlanBenefits } from './data';
import { HtmlIds } from '../../../../constants';
import { QuestionFilledIcon } from '../../../../wag-react/next-components/icons';
import { Box } from '../../../../wag-react/next-components/box';
import { Flex } from '../../../../wag-react/next-components/Flex';
import { Typography } from '../../../../wag-react/components/Typography';
export type WellnessPlansSectionV2Props = {
  onHelpIconClick: (name: string, description: ReactNode) => void;
};
export const WellnessPlansSectionV2 = ({
  onHelpIconClick
}: WellnessPlansSectionV2Props) => <>
    <Box id={HtmlIds.WELLNESS_PLANS_SECTION} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <SectionHeading variant="h3" mb={['16px', '32px']} data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx">
        The benefits of Wag! Wellness
      </SectionHeading>

      {/* Desktop only */}
      <Container display={['none', null, 'flex']} data-sentry-element="Container" data-sentry-source-file="index.tsx">
        <Flex bg="white" flex={1} flexDirection="column" px="16px" flexWrap="wrap" maxHeight="400px" alignContent="center" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          {Object.keys(WellnessPlanBenefits).map((key: string) => <Flex key={key} justifyContent="space-between" minHeight="65px" alignItems="center" alignContent="center" width={['300px', '400px', '500px']} px="20px" py="8px" my="8px" mx={['unset', '14px']} backgroundColor="white" borderRadius="8px" border="1px solid #E5E5E5">
              <Typography color="#727272" fontFamily="muli" fontWeight="600" lineHeight="46px" fontSize={['16px', '18px']} m={0}>
                {WellnessPlanBenefits[key]}
              </Typography>

              <QuestionFilledIcon onClick={() => {
            onHelpIconClick(WellnessPlanBenefits[key], WELLNESS_PLAN_BENEFIT_DETAILS[WellnessPlanBenefits[key]]);
          }} cursor="pointer" color="#D8D8D8" height="24px" width="24px" />
            </Flex>)}
        </Flex>
      </Container>

      {/* Mobile & Tablet only */}
      <Box display={['block', null, 'none']} my={2} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
          <WellnessPlanTable onIconClick={(activeBenefitName: string) => {
          onHelpIconClick(activeBenefitName, WELLNESS_PLAN_BENEFIT_DETAILS[activeBenefitName]);
        }} data-sentry-element="WellnessPlanTable" data-sentry-source-file="index.tsx" />
        </Container>
      </Box>
    </Box>
  </>;